import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import UserAgent from './components/UserAgent';
import { AgentsWrapper, CardsGrid, Wrapper } from './styled';
import { selectAgentsSelected, SelectShowCloudAgents } from 'store/Agents/selectors';
import { selectPage } from 'store/Filters/selectors';
import AgentDetail from '../../../AgentDetail';

const UserAgents = ({ agents }) => {
  const showAgentDetail = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const agentsSelected = useSelector(selectAgentsSelected);
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const entity = showCloudAgents ? 'cloudAgents' : 'agents';
  const page = useSelector((state) => selectPage(entity, state));
  const [agentsList, setAgentsList] = useState(agents);

  useEffect(() => {
    setAgentsList(agents);
  }, [page, agents]);

  if (isEmpty(agents)) return null;
  return (
    <Wrapper>
      {showAgentDetail && <AgentDetail /> }
      <AgentsWrapper>
        <CardsGrid>
          { agentsList.map((agent) => (
            <UserAgent key={ agent.id } data={ { agent, selected: some(agentsSelected, { id: agent.id }) } } />
          )) }
        </CardsGrid>
      </AgentsWrapper>
    </Wrapper>
  );
};
export default UserAgents;
